__turbopack_context__.v({
  "action": "style-module-scss-module__w1TtlG__action",
  "actions": "style-module-scss-module__w1TtlG__actions",
  "avatar": "style-module-scss-module__w1TtlG__avatar",
  "avatarImage": "style-module-scss-module__w1TtlG__avatarImage",
  "bio": "style-module-scss-module__w1TtlG__bio",
  "divider": "style-module-scss-module__w1TtlG__divider",
  "experience": "style-module-scss-module__w1TtlG__experience",
  "grid": "style-module-scss-module__w1TtlG__grid",
  "label": "style-module-scss-module__w1TtlG__label",
  "name": "style-module-scss-module__w1TtlG__name",
  "person": "style-module-scss-module__w1TtlG__person",
  "personInfo": "style-module-scss-module__w1TtlG__personInfo",
  "personLink": "style-module-scss-module__w1TtlG__personLink",
  "role": "style-module-scss-module__w1TtlG__role",
  "wrapper": "style-module-scss-module__w1TtlG__wrapper",
});
